import { createAction } from '@reduxjs/toolkit';

// Shared slice for the first-class content blocks
// (features/gallery/review/blog/discount/timer/social/html).
export const contentStore = createAction('emailsContent/store');
export const contentClear = createAction('emailsContent/clear');

export const contentUpdateHeadingTitle = createAction('emailsContent/updateHeadingTitle');
export const contentUpdateHeadingDescription = createAction('emailsContent/updateHeadingDescription');
export const contentUpdateItems = createAction('emailsContent/updateItems');
export const contentUpdateView = createAction('emailsContent/updateView');
export const contentUpdateCode = createAction('emailsContent/updateCode');
export const contentUpdateTerms = createAction('emailsContent/updateTerms');
export const contentUpdateLabel = createAction('emailsContent/updateLabel');
export const contentUpdateEndDate = createAction('emailsContent/updateEndDate');
export const contentUpdateHtml = createAction('emailsContent/updateHtml');
export const contentUpdateUrl = createAction('emailsContent/updateUrl');
export const contentUpdateReadMoreLabel = createAction('emailsContent/updateReadMoreLabel');
